import { baseEnvironment, AUTH_CAPTCHA_BYPASS_TOKEN, METADATA_WRITER } from "./environment.base";
import { Environment } from "./types";

export const environment: Environment = {
  ...baseEnvironment,
  ENV: "development",
  name: "Development",
  AUTH_CLIENT_ID: "9e09cfdb-b232-4f65-9a65-755865e73376",
  AUTH_CAPTCHA_BYPASS_TOKEN,
  AUTH_FORCE_LICENSE: true,
  AUTH_FORCE_ORGANIZATION: true,
  PROTECTED_URIS: {
    ASSET_MODULE: "https://asset-module.api.ca.connect.dev-evcnt.com/api/v1",
    VISOL_API: "https://visol.connect.dev-evcnt.com/api"
  },
  ASSET_MODULE_OFFLINE: "http://localhost:5100/api/v1",
  VISOL_WEBSITE: "https://visol.connect.dev-evcnt.com",
  reportTemplateBuilderUrl: "https://rtb.connect.dev-evcnt.com/",
  powerBiEndpointUrl: "https://app.powerbi.com/",
  measurementServiceUrl: "http://localhost:8053",
  METADATA_WRITER,
  CONNECTORS: {
    GENERAL_ELECTRIC: "ba57e35b-b952-4954-859c-ad301c7283f7"
  },
  DEBUG_AUTH_FLOW: true
};
